import { request } from '@/utils/request'

export default {
    getExecutiveRatingsAsync(id, ratingCategory, group, startDate = null, endDate = null) {
        return request.get(`/api/ratings/executives/${id}`, {
            group,
            startDate,
            endDate,
            category: ratingCategory,
            ratingCategory,
        })
    },
}

export const EXECUTIVE_RATING_TEXT = `ManagementTrack Rating (MT Rating) is a proprietary rating and predictive of one year alpha. MT Rating is based on the company's exchange and sector where the executive is serving - comparisons are relative to peer set.`

export const COMPANY_RATING_TEXT = `A company's ManagementTrack Rating is a combination of the CEO's (weighted 60%), CFO's (weighted 20%), and the COO's (weighted 20%) ManagementTrack Rating.`

export const NO_RATING_TEXT = `No rating available; this executive has not held a C-suite role at a public company.`
